import { INCLUDE_COVER_MANAGER, INCLUDE_RECOVERY_FORM } from '@constants/feedbacks';

export const splitSurveyGroups = (surveys = [], { isCoverManagerConnected = false } = {}) => ({
    surveys: surveys.filter(item => item !== INCLUDE_COVER_MANAGER && item !== INCLUDE_RECOVERY_FORM),
    includeCoverManager: isCoverManagerConnected && surveys.includes(INCLUDE_COVER_MANAGER),
    includeRecoveryForm: surveys.includes(INCLUDE_RECOVERY_FORM),
});

export const analyticsSurveyGroups = (surveys = [], options = {}) => {
    const { surveys: templates, includeCoverManager } = splitSurveyGroups(surveys, options);
    return { surveys: templates, includeCoverManager };
};
